<template>
  <div>
    <div class="instruction_title text-left para-mrgn-20" v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }" v-html="question.formattedBody" />
    <b-form-radio-group @click.once="$emit('onClick', question)" v-model="question.optionId" @change="onAnswerChange" :disabled="isFieldDisabled" stacked>
      <b-form-radio class="light" v-for="option in componentData.options" :key="option.id" :value="option.id"
        ><span
          v-translate:dynamic_string="{
            key: widget.getDynamicStringKey(translationKeyInitial, option),
            val: lang,
            optionId: option.id,
            html: option.label
          }"
          v-html="option.label"
        ></span
      ></b-form-radio>
    </b-form-radio-group>
    <span class="text-danger pl-5 fw-bold pt-10" v-if="hasFieldError">{{ fieldErrorText }}</span>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import { Widget } from "@/components/services/participant-service";
export default {
  name: "boolean",
  mixins: [langTranslate],
  data() {
    return {
      widget: new Widget(),
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {}
    };
  },
  mounted() {
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  methods: {
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    clearAnswer(){
      this.question.optionId = "";
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  }
};
</script>
